import { classnames } from 'Utils/classnames/classnames.utils';
import React, { useState } from 'react';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { Icon } from 'Components/frameworks/icon/Icon';
import { DropDown } from 'Components/frameworks/drop-down/DropDown';
import { useAppContext } from 'Context/ReactAppContext';
import { NbNights } from './NbNights';

export const CriteriaWhenReassuranceDropdown = ({ nbNightsProps }) => {
  const { isSeller } = useAppContext();

  const [isExpanded, setIsExpanded] = useState(false);
  const { isDesktop } = useResponsive();

  // eslint-disable-next-line clubmed/no-fake-component
  const renderTrigger = () => (
    <button
      type="button"
      {...(isDesktop
        ? {
            onMouseEnter: () => {
              setIsExpanded(true);
            },
            onMouseLeave: () => {
              setIsExpanded(false);
            },
          }
        : {
            onClick: () => {
              setIsExpanded(!isExpanded);
            },
          })}
      className={classnames('h-full leading-0', {
        'criteria-arrow': isExpanded && !isDesktop,
      })}
    >
      <Icon name={ICONS.INFORMATION} width="1.125rem" />
    </button>
  );

  return (
    <DropDown
      className="h-full lg:relative lg:leading-0"
      contentClassName="lg:mt-10 lg:w-380"
      hasArrow={isDesktop}
      isExpanded={isExpanded}
      onClose={() => {
        setIsExpanded(false);
      }}
      renderTrigger={renderTrigger}
      theme="hollow"
    >
      {() => (
        <div className="p-15 text-12 leading-normal text-mediumGrey lg:p-20">
          {!isSeller && nbNightsProps.duration && <NbNights {...nbNightsProps} />}
          {t('faceting.when.reinsurance')}
        </div>
      )}
    </DropDown>
  );
};
